<template>
  <h2>Graph</h2>
  <div style="max-width: 1000px; margin: 0 auto">
    <Bar
      v-if="monthTotals.labels.length"
      id="totalChart"
      :options="chartOptions"
      :data="monthTotals"
    ></Bar>
    <p v-else>Loading chart...</p>
  </div>
</template>

<script>
//import chart from "chart.js/auto";
import router from "@/router";
import axios from "axios";
import { server } from "@/utils/helper";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  components: { Bar },
  data() {
    return {
      monthTotals: {
        labels: [],
        datasets: [
          {
            label: "Total Hours",
            data: [],
            backgroundColor: "#00F2FE",
            hoverBackgroundColor: "#06B6D4",
            borderRadius: 4,
          },
        ],
      },
      fetchError: false,
      errorMessage: "",
      events: [],
      months: [],
      chartOptions: {
        plugins: {
          tooltip: {
            backgroundColor: "#1E293B", // Matches your tech-surface color
            titleColor: "#00F2FE", // Cyan tooltip headers
            bodyColor: "#FFFFFF", // Clean white text values
            borderColor: "#334155", // Thin structural border
            borderWidth: 1,
          },
          legend: {
            display: false,
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2,
        scales: {
          // 3. Brighten the X and Y Axis text & clean up gridlines
          x: {
            grid: {
              color: "rgba(51, 65, 85, 0.3)", // Subtle #334155 grid borders
              drawOnChartArea: true,
            },
            ticks: {
              color: "#94A3B8", // Matches your text-muted custom gray
              font: {
                family: "'Montserrat', 'Segoe UI', sans-serif",
                size: 12,
              },
            },
          },
          y: {
            grid: {
              color: "rgba(51, 65, 85, 0.3)",
              drawOnChartArea: true,
            },
            ticks: {
              color: "#94A3B8",
              font: {
                family: "'Montserrat', 'Segoe UI', sans-serif",
                size: 12,
              },
            },
          },
        },
      },
    };
  },
  async created() {
    await this.calculateTotals();
  },
  methods: {
    async calculateTotals() {
      const bearerToken = localStorage.getItem("jwt");
      if (!bearerToken) {
        this.fetchError = true;
        this.errorMessage = "Please log in to see events.";
        router.push("/login");
        return;
      }

      try {
        const { data } = await axios.get(`${server.baseUrl}/months`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        });
        this.months = data;
      } catch (error) {
        this.fetchError = true;
        if (error.response?.status === 404) {
          this.errorMessage = "No data!";
        } else if (error.response?.status === 401) {
          this.errorMessage = "Please log in to see events.";
          router.push("/login");
        } else {
          this.errorMessage = "Something went wrong. Please try again.";
        }
        return;
      }

      this.monthTotals.labels = this.months.map((m) => m.month);
      this.monthTotals.datasets[0].data = this.months.map((m) => m.time);
    },
  },
};
</script>
